import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import FormControl from "@material-ui/core/FormControl";
import { connect } from "react-redux";
import * as actions from "../../store/actions/index";
import Iframe from "react-iframe";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Input from "@material-ui/core/Input";
import Button from "@material-ui/core/Button";
import { withRouter } from "react-router-dom";
import InputLabel from "@material-ui/core/InputLabel";
import CardActions from "@material-ui/core/CardActions";
import ChatBoxMoreInfo from "./ChatBoxMoreInfo";
import PropTypes from "prop-types";
import axios from 'axios';

const styles = {
  root: {
    width: "100vw",
    // minWidth: '150px',
    // height: '500px',
    // minHeight: '350px',
    align: "center",
    //overflowX: 'auto',
    //display: 'column',
    alignItem: "center",
    // margin: '0 Auto',
  },
  formControl: {
    // margin: theme.spacing.unit * 3,
  },
  group: {},
  radio: {
    "&$checked": {
      color: "#B71C1C",
    },
  },
  checked: {},
  progress: {
    /*display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignItem: 'center',*/
    flexDirection: "column",
    // margin: theme.spacing.unit * 3,
  },
  button: {
    display: "flex",
    justifyContent: "center",
    // margin: '0 Auto',
  },
  InputLabel: {
    fontSize: "14px",
  },
  rightInput: {
    marginLeft: "50px",
  },
  country: {
    marginTop: "15px",
    marginBottom: "10px",
  },
  hkidPassport: {
    marginTop: "15px",
    marginBottom: "10px",
  },
};

class SentEmailStatus extends Component {
  state = {
    Rcreated: false,
    Ccreated: false
  };

  handleChange = (userType) => {
    let url = `${process.env.REACT_APP_SERVER_HOSTNAME}:${process.env.REACT_APP_SERVER_PORT}/createEmailSentPDF`
    this.setState({
      Rcreated: false,
      Ccreated: false
    })
    const data = {
      caseId: parseInt(this.props.caseData.caseId),
      userType: userType
    }
    axios.post(url, {
      ...data
    })
    .then((response) => {
      console.log('created ##')
      if (userType == 'claimant'){
        this.setState({
          Ccreated: true
        })
      }
      else{
        this.setState({
          Rcreated: true
        })
      }

    })
  }

  render() {
    const { classes } = this.props;

    return (
      <div style={{ marginLeft:'20px' }}>
        {/* <br></br> */}
        {/* <b style={{marginLeft:'15px'}}>{this.context.t("RespondentSentEmails")}</b><br></br> */}
        {/* <Button
            variant="contained"
            type="submit"
            color="primary"
            disabled={this.props.submitInProgress}
            className={classes.bInput}
            onClick={()=> {this.handleChange('claimant')}}
            style={{
              fontSize: "14px",
              marginBottom: "15px",
              textTransform: 'capitalize'
            }}
          >{this.context.t("Download Claimant Sent Email Statuses")}</Button>          { this.state.Ccreated && <a style={{color:'red'}} target="_blank" href={`${process.env.REACT_APP_SERVER_HOSTNAME}:9000/getPdf/?id=${this.props.caseData.conversationId}_claimantemailSent`}>{this.context.t("Download PDF")}</a>}<br></br>
          <Button
            variant="contained"
            type="submit"
            color="primary"
            disabled={this.props.submitInProgress}
            className={classes.bInput}
            onClick={()=> {this.handleChange('respondent')}}
            style={{
              fontSize: "14px",
              marginBottom: "15px",
              textTransform: 'capitalize'
            }}
          >{this.context.t("Download Respondent Sent Email Statuses")}</Button>&nbsp;&nbsp;&nbsp;
          { this.state.Rcreated && <a style={{color:'red'}} target="_blank" href={`${process.env.REACT_APP_SERVER_HOSTNAME}:9000/getPdf/?id=${this.props.caseData.conversationId}_respondentemailSent`}>{this.context.t("Download PDF")}</a>} */}
          {/* <Card className={classes.root}>
            <CardContent>
            {this.props.caseData.sentEmails !== undefined && this.props.caseData.sentEmails.respondent.map((sentEmail, index) => (
                <div>
                  {sentEmail.date !== undefined && <label style={{ fontSize: "12px" }}>{this.context.t("date")} - {sentEmail.date}</label>}<br></br>
                  <label style={{ fontSize: "12px" }}>Accepted emails:&nbsp;</label>
                  {
                    sentEmail.info !== undefined && 
                    sentEmail.info.accepted.map((email, index) => (
                      <label style={{ fontSize: "12px" }}> {email}, </label>
                    ))
                  }
                  <br></br>
                  <label style={{ fontSize: "12px" }}>Rejected emails:&nbsp;</label>
                  {
                    sentEmail.info !== undefined && 
                    sentEmail.info.rejected.map((email, index) => (
                      <label style={{ fontSize: "12px" }}> {email}, </label>
                    ))
                  }
                  <br></br>
                  {sentEmail.mailOptions !== undefined && <label style={{ fontSize: "12px" }}>Subject - {sentEmail.mailOptions.subject}</label>}<br></br>
                  {sentEmail.mailOptions !== undefined && <label style={{ fontSize: "12px" }}>Content - {sentEmail.mailOptions.html}</label>}<br></br>
                </div>
              ))}
            </CardContent>
          </Card>
        <br></br>
        <b style={{marginLeft:'15px'}}>{this.context.t("ClaimantSentEmails")}</b>
          <Card className={classes.root}>
            <CardContent>
            {this.props.caseData.sentEmails !== undefined && this.props.caseData.sentEmails.claimant.map((sentEmail, index) => (
                <div>
                  {sentEmail.date !== undefined && <label style={{ fontSize: "12px" }}>{this.context.t("date")} - {sentEmail.date}</label>}<br></br>
                  <label style={{ fontSize: "12px" }}>Accepted emails:&nbsp;</label>
                  {
                    sentEmail.info !== undefined && 
                    sentEmail.info.accepted.map((email, index) => (
                      <label style={{ fontSize: "12px" }}> {email}, </label>
                    ))
                  }
                  <br></br>
                  <label style={{ fontSize: "12px" }}>Rejected emails:&nbsp;</label>
                  {
                    sentEmail.info !== undefined && 
                    sentEmail.info.rejected.map((email, index) => (
                      <label style={{ fontSize: "12px" }}> {email}, </label>
                    ))
                  }
                  <br></br>
                  {sentEmail.mailOptions !== undefined && <label style={{ fontSize: "12px" }}>Subject - {sentEmail.mailOptions.subject}</label>}<br></br>
                  {sentEmail.mailOptions !== undefined && <label style={{ fontSize: "12px" }}>Content - {sentEmail.mailOptions.html}</label>}<br></br>
                </div>
              ))}
            </CardContent>
          </Card> */}
      </div>
    );
  }
}

// export default withStyles(styles)(ArbitratorAcceptRejectBox);
const mapStateToProps = (state) => {
  return {
    caseId: state.caseInfo.caseId,
    caseData: state.caseInfo.caseData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    AdminAcceptReject: (caseId, status) =>
      dispatch(actions.AdminAcceptReject(caseId, status)),
  };
};

SentEmailStatus.contextTypes = {
  t: PropTypes.func,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(withRouter(SentEmailStatus)));
